
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership-program/technology-partners",
      function () {
        return require("private-next-pages/partnership-program/technology-partners/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership-program/technology-partners"])
      });
    }
  